var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 260 260",
    enableBackground: "new 0 0 260 260",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0.7,207.7h55.6v-51.9H0C0,155.7,0,201.5,0.7,207.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M143.6,210.6c19.6,0,36.5-7.3,50.8-21.7c14.3-14.5,21.5-31.7,21.5-51.7c0-20.5-7.2-37.8-21.6-52 C179.9,71.1,162.2,64,141.2,64c-10.5,0-20.8,2.3-30.9,6.9c-10,4.6-18.3,10.8-24.8,18.6c-11.3,13.6-16.9,31.1-16.9,52.7V260h52.8 v-49.7C131.2,210.5,141.7,210.6,143.6,210.6z M121.4,144.3c0-18.7,6.8-28.1,20.3-28.1c5.6,0,10.5,2,14.5,5.9 c4.1,3.9,6.1,8.6,6.1,14.2c0,5.6-2,10.4-5.9,14.4c-3.9,4.1-8.6,6.1-14.1,6.1c-0.5,0-13.7,0-21,0.1V144.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#242423",
    d: "M199.2,0H60.8C27.2,0,0,27.2,0,60.8v95h56.3v51.9H0.7C4.8,237.2,30.1,260,60.8,260h7.8V142.3 c0-21.6,5.6-39.1,16.9-52.7c6.5-7.8,14.8-14,24.8-18.6c10-4.6,20.3-6.9,30.9-6.9c21,0,38.7,7.1,53.1,21.2 c14.4,14.1,21.6,31.4,21.6,52c0,20-7.2,37.2-21.5,51.7s-31.3,21.7-50.8,21.7c-1.8,0-12.3-0.1-22.2-0.3V260h77.8 c33.6,0,60.8-27.2,60.8-60.8V60.8C260,27.2,232.8,0,199.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242423",
    d: "M162.3,136.2c0-5.6-2-10.3-6.1-14.2c-4-3.9-8.9-5.9-14.5-5.9c-13.6,0-20.3,9.4-20.3,28.1v12.5 c7.3,0,20.6-0.1,21-0.1c5.5,0,10.1-2,14.1-6.1C160.4,146.6,162.3,141.8,162.3,136.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.8bce880a175a468f7930048fba14ff7f.svg";
export { ForwardRef as ReactComponent };